export default {
  header: 'Nous devons vérifier votre numéro de téléphone',
  buttons: {
    confirm: 'Confirmer',
  },
  toasts: {
    invalid_code: 'Code invalide. Veuillez réessayer.',
  },
};
